module.exports = __webpack_public_path__ + "media/images/linkedin-f00ba06e.png";